import { IDynamicObject } from "xa-generics";
import hu from "./HU.json";

export const T = (key: string): string => {
    return (hu as IDynamicObject)[key] || key;
};
